/* Feral hero marquee behaviour.
 *
 * Lives here, not inline in the section, because the hero renders inside
 * #header-group and Horizon re-creates that group's content on load. Scripts
 * created by that kind of DOM morphing never execute - the same trap that bit
 * the cart drawer earlier. The markup was in the served HTML and simply never
 * ran, which left the design carousel frozen on its first design and the menu
 * bar permanently translucent.
 *
 * Loaded from layout/theme.liquid before </body>, so it is parsed normally and
 * runs wherever the hero happens to live. Everything is guarded, so it is inert
 * on pages without a hero.
 */
(function () {
  function boot() {

  /* Flip the header between translucent and solid.

     Driven by scroll position against the hero's measured height, not by a
     sentinel element. The sentinel version never worked: the div rendered in
     the section source but was not in the DOM at runtime - the header group
     evidently does not keep arbitrary nodes alongside the section - while the
     CSS from the same file applied fine. A scroll position cannot go missing.

     The theme's own data-sticky-state was the other candidate and is useless
     here: it reads "active" at the top of the page and never changes.

     Passive listener, and the work is one comparison, so it is cheap enough to
     run per scroll event without rAF throttling. */
  (function () {
    function init() {
      var header = document.querySelector('header-component.header');
      var hero = document.querySelector('.fh');
      if (!header || !hero) return false;
      function update() {
        var past = window.scrollY >= Math.max(0, hero.offsetHeight - header.offsetHeight);
        header.dataset.fhStuck = past ? 'true' : 'false';
      }
      update();
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      return true;
    }
    if (!init()) {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
      else requestAnimationFrame(init);
    }
  })();

(function () {
  /* By class, not by id: the id carries the Liquid section id, which cannot
     survive being lifted out into a static asset. */
  var root = document.querySelector('.fh');
  if (!root) return;
  var layers = root.querySelectorAll('.fh-layer');
  if (layers.length < 2) { if (layers[0]) layers[0].classList.add('is-on'); return; }
  var i = 0, timer = null, visible = true;
  /* Read from the section rather than baked in, so the theme-editor setting
     still drives it now the code lives outside the Liquid. */
  var every = parseInt(root.dataset.fhInterval, 10) || 3000;
  var fade = parseInt(root.dataset.fhFade, 10);
  if (fade >= 0) root.style.setProperty('--fh-fade', fade + 'ms');
  layers[0].classList.add('is-on');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function step() { layers[i].classList.remove('is-on'); i = (i + 1) % layers.length; layers[i].classList.add('is-on'); }
  function start() { if (!timer && !reduce && visible && !document.hidden) timer = setInterval(step, every); }
  function stop() { clearInterval(timer); timer = null; }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { visible = e[0].isIntersecting; visible ? start() : stop(); }).observe(root);
  }
  document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  start();
})();

  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
